// Utils
import { resolveObjectOrNestedObjectsToObjectIds } from './resolveObjectOrNestedObjectsToObjectIds';
/**
 * Encodes the sub objects of a given object
 *
 * @template T extends object
 * @param {T} values
 *
 * @return {T}
 */
export var resolveNestedObjectsToObjectIdsForObject = function (values) {
    var result = {};
    Object.keys(values).forEach(function (key) {
        result[key] = resolveObjectOrNestedObjectsToObjectIds(values[key]);
    });
    return result;
};
//# sourceMappingURL=resolveNestedObjectsToObjectIdsForObject.js.map